import { render, staticRenderFns } from "./CreateProjectDetails.vue?vue&type=template&id=340d8934"
import script from "./CreateProjectDetails.vue?vue&type=script&lang=ts"
export * from "./CreateProjectDetails.vue?vue&type=script&lang=ts"
import style0 from "./CreateProjectDetails.vue?vue&type=style&index=0&id=340d8934&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports